import React, { memo } from 'react';
import { Image } from '@/components';
import { useMasterData } from '@/contexts/profile';
type TitlePartialProps = {
  name: string;
  className?: string;
  cs?: string;
};

const TitlePartial = ({ name, className, cs }: TitlePartialProps) => {
  const masterData = useMasterData();
  const { theme } = masterData ?? {};
  const { icon_category_url } = theme ?? {};

  return (
    <div
      className={`_title tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-justify-center  tw-w-full  tw-relative ${className}`}
    >
      <div className="tw-flex tw-items-center tw-w-max  tw-px-5 tw-justify-center ">
        {icon_category_url ? (
          <Image src={icon_category_url} alt="star" className="tw-h-8 tw-w-8" />
        ) : (
          <Image src={'/diamond.svg'} alt="star" className="tw-h-5 tw-w-5" />
        )}
        <h2
          className={`tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold ${cs}`}
        >
          {name}
        </h2>
        {icon_category_url ? (
          <Image src={icon_category_url} alt="star" className="tw-h-8 tw-w-8" />
        ) : (
          <Image src={'/diamond.svg'} alt="star" className="tw-h-5 tw-w-5" />
        )}
      </div>
    </div>
  );
};
export default memo(TitlePartial);
